
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 39.33 39.33"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19.66","cy":"19.66","r":"19.66","fill":"#47b547"}}),_c('path',{attrs:{"fill":"#fff","d":"M16.65 30.25l-10.69-9.5 3.34-3.77 7.23 6.43 13.43-12.74 3.47 3.66-16.78 15.92z"}})])
          )
        }
      }
    